import { useIsFeatureVisibleToOrg } from '@/utils/featureFlags';

import type { CategoryType, WidgetDataSource } from '../../types';
import { GigaPieWidgetCloudscape } from './GigaPieWidget.cloudscape';
import { GigaPieWidgetHighcharts } from './GigaPieWidget.highcharts';
import type { GigaPieWidgetProps } from './GigaPieWidgetProps';

export const GigaPieWidget = <
  TDataSource extends WidgetDataSource,
  TCategory extends CategoryType,
>(
  props: GigaPieWidgetProps<TDataSource, TCategory>
) => {
  const highchartsEnabled = useIsFeatureVisibleToOrg('highcharts');

  if (highchartsEnabled) {
    return <GigaPieWidgetHighcharts {...props} />;
  }

  return <GigaPieWidgetCloudscape {...props} />;
};
